module.exports = __webpack_public_path__ + "static/media/textchat_2.bba095c8.ico";